import React, { Component } from 'react';
import styles from './Prescription-List.module.scss';
import MaterialTable from 'material-table';
import {Link} from 'react-router-dom';

import { forwardRef } from 'react';
import { AddBox, Check, Clear, DeleteOutline, ChevronRight, Edit, SaveAlt, FilterList, FirstPage, LastPage, ChevronLeft, Search, ArrowDownward, Remove, ViewColumn } from "@material-ui/icons";

class PrescriptionListComponent extends Component {
    render() {

        function MaterialTableDemo(data) {
            const [state, setState] = React.useState({
                columns: [
                    { title: "Sr. No.", render: rowData => rowData.tableData.id + 1  },
                    { title: 'Doctor Name', field: 'doctor_name', cellStyle: { fontSize: '.9rem' } , render: doctorLink => (<Link to={{ pathname: '/foo/'+`${doctorLink.id}` }}>{ doctorLink.doctor_name }</Link>) },
                    { title: 'Patient Name', field: 'patient_name', cellStyle: { fontSize: '.9rem' } },
                    { title: 'Rx Date', field: 'add_date', cellStyle: { fontSize: '.9rem' } },
                    { title: 'Action', field: 'action', cellStyle: { fontSize: '.9rem' }, render: patientAction => (<a href={"https://dr.drray24.in/prescription/"+patientAction.prescription+"/"+patientAction.hash} target="_blanck" className={`my-btn ${styles.actionView}`}>View</a>)  },
                  ],
                  data: data.pre,
            });

            const tableIcons = {
                Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
                Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
                Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
                Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
                DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
                Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
                Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
                FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
                LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
                NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
                ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
                Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
                SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
                ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
                ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
            }
          
            return (
              <MaterialTable
                title="Doctors"
                columns={state.columns}
                data={state.data}
                icons={tableIcons}
              />
            );
        }

        return(
            <MaterialTableDemo pre={this.props.pre} />
        );
    }
}

export default PrescriptionListComponent;